import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  const day = Number(frontmatter.path.slice(-3))
  const nDays = 255  // Hard coded number of journal posts
  return (
    <Layout>
    <div className="blog-post-container">
      <div className="blog-post">
        {day > 1  &&
          <a href={frontmatter.path.replace(/\d\d\d/, match => String(Number(match) - 1).padStart(3, '0'))}>Prev</a>
        }
        {day !== nDays &&
          <a href={frontmatter.path.replace(/\d\d\d/, match => String(Number(match) + 1).padStart(3, '0'))}>Next</a>
        }
        <h1>{frontmatter.title}</h1>
        <h2>{frontmatter.date}</h2>
        <div
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`
